<template>
    <RegisterStep
        :previous-route="previousRoute"
        :ready="ready"
        :loading="loading"
        v-bind="$attrs"
        @submit="handleStepSubmitted"
    >
        <template v-if="session.options_help_text">
            <div class="mb-4" v-html="session.options_help_text"></div>
        </template>

        <RegistrantSections :order="currentOrder" v-slot="{ registrant, i }">
            <Field class="mb-0"
                :name="`registrants.${i}.options`"
                :errors="errors"
                v-slot="{ error }"
            >
                <RegistrantCard :registrant="registrant" :order="order" :error="error">
                    <template v-if="session.options_allow_multiple">
                        <b-form-checkbox-group class="cursus-checkboxes" v-model="registrant.options" stacked>
                            <template v-for="option in session.options">
                                <OptionItem
                                    :option="option"
                                    :component="BFormCheckbox"
                                />
                            </template>
                        </b-form-checkbox-group>

                        <template v-if="min || max">
                            <div class="small mt-2 text-muted">
                                <template v-if="min === max">
                                    Choisissez {{ min }} option{{ plural(min) }}
                                </template>
                                <template v-else-if="!max">
                                    Choisissez au moins {{ min }} option{{ plural(min) }}
                                </template>
                                <template v-else-if="!min">
                                    Choisissez jusqu'à {{ max }} option{{ plural(max) }}
                                </template>
                                <template v-else>
                                    Choisissez entre {{ min }} et {{ max }} options
                                </template>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <b-form-radio-group
                            class="cursus-radios"
                            :checked="registrant.options ? registrant.options[0] : null"
                            @input="registrant.options = [$event]"
                            stacked
                        >
                            <template v-for="option in session.options">
                                <OptionItem
                                    :option="option"
                                    :component="BFormRadio"
                                />
                            </template>
                        </b-form-radio-group>
                    </template>
                </RegistrantCard>
            </Field>
        </RegistrantSections>
    </RegisterStep>
</template>

<script>
    import clone from 'lodash/clone';
    import { BFormCheckbox, BFormCheckboxGroup, BFormRadio, BFormRadioGroup } from 'bootstrap-vue';
    import { plural } from "../../../util";
    import RegisterStep from "../RegisterStep";
    import { postOrderOptions } from "../../../api";
    import Field from "../../Field";
    import RegistrantSections from "../RegistrantSections";
    import RegistrantCard from "../RegistrantCard";
    import OptionItem from "./options/OptionItem.vue";

    export default {
        components: {
            OptionItem,
            RegistrantCard,
            RegistrantSections,
            Field,
            RegisterStep,
            BFormCheckboxGroup,
            BFormRadioGroup
        },
        props: {
            session: Object,
            order: Object,
            nextRoute: Object,
            previousRoute: Object,
        },
        data() {
            return {
                ready: false,
                currentOrder: clone(this.order),
                errors: null,
                loading: false,
                BFormCheckbox,
                BFormRadio,
            }
        },
        computed: {
            min() {
                return Math.min(this.session.options_minimum, this.session.options.length);
            },
            max() {
                return this.session.options_maximum < this.session.options.length
                    ? this.session.options_maximum
                    : null;
            },
        },
        methods: {
            plural,
            handleStepSubmitted() {
                const { courseId, sessionId, orderId } = this.$route.params;
                this.loading = true;
                this.errors = null;
                postOrderOptions({ courseId, sessionId, orderId, data:this.currentOrder })
                    .then(order => {
                        this.currentOrder = order;
                        this.$emit('update:order', order);
                        this.$router.push(this.nextRoute);
                    })
                    .catch(error => {
                        if(error.response?.status === 422) {
                            this.errors = error.response.data.errors;
                        } else {
                            return Promise.reject(error);
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            init() {
                this.ready = true;
            }
        },
        created() {
            this.init();
        },
    }
</script>
